import script from "./SideNavigation.vue?vue&type=script&setup=true&lang=js"
export * from "./SideNavigation.vue?vue&type=script&setup=true&lang=js"

import "./SideNavigation.vue?vue&type=style&index=0&id=109c0fd5&lang=css"

const __exports__ = script;

export default __exports__